/*
 *  This has been generated using the Synergy STDev tool.
 *  Any modifications will be lost after the next build
 */
import * as sis from './SISApp'
import { componentApi, loadTranslations } from 'common'


export class RoleDashboardApi {
  async GetUserInfo() : Promise<sis.DashboardUserInfo> {
    return await componentApi.call('sis', 'sis-role-dashboard', 'RoleDashboardApi', 'GetUserInfo', {
    });
  }
  async GetConfiguration() : Promise<sis.RoleConfiguration> {
    return await componentApi.call('sis', 'sis-role-dashboard', 'RoleDashboardApi', 'GetConfiguration', {
    });
  }
  async GetUserSuggestions() : Promise<Array<sis.ViewSuggestion>> {
    return await componentApi.call('sis', 'sis-role-dashboard', 'RoleDashboardApi', 'GetUserSuggestions', {
    });
  }
  async GetEnrollmentActivityCount() : Promise<number> {
    return await componentApi.call('sis', 'sis-role-dashboard', 'RoleDashboardApi', 'GetEnrollmentActivityCount', {
    });
  }
  async GetEnrollmentHistory(page : number) : Promise<Array<sis.StudentEnrollmentHistoryEntry>> {
    return await componentApi.call('sis', 'sis-role-dashboard', 'RoleDashboardApi', 'GetEnrollmentHistory', {
      page,
    });
  }
  async OpenDetachedView(viewGU : string, studentGU : string, focusOrgGU : string, focusYearGU : string) : Promise<sis.RevResponse> {
    return await componentApi.call('sis', 'sis-role-dashboard', 'RoleDashboardApi', 'OpenDetachedView', {
      viewGU,
      studentGU,
      focusOrgGU,
      focusYearGU,
    });
  }
  async ExecuteAction(actionId : string, viewState : sis.ViewState) : Promise<sis.RevResponse> {
    return await componentApi.call('sis', 'sis-role-dashboard', 'RoleDashboardApi', 'ExecuteAction', {
      actionId,
      viewState,
    });
  }
  async OpenSuggestion(viewGU : string, viewType : string) : Promise<sis.RevResponse> {
    return await componentApi.call('sis', 'sis-role-dashboard', 'RoleDashboardApi', 'OpenSuggestion', {
      viewGU,
      viewType,
    });
  }
}
export default new RoleDashboardApi()
